export const DateTime = {
  fromJSDate () {
    throw new TypeError()
  }
}
